import styled from 'styled-components';
import { space, font, color, query } from '@design/templateFns';

export const ModalButton = styled.button<{ $isDisable?: boolean }>`
  ${font('subhead-sm')}
  padding: ${space('sm')} ${space('xl')};
  cursor: pointer;
  color: ${color('bg')};
  background-color: ${color('fg')};
  border: 1px solid transparent;
  border-radius: 4px;
  ${({ $isDisable }) =>
    $isDisable &&
    `background-color: lightgrey;
     cursor: not-allowed;
`}
`;

export const ModalButtonSecond = styled(ModalButton)`
  color: ${color('fg')};
  background-color: ${color('bg')};
  border-color: ${color('fg')};
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
`;

export const ModalButtonWrapperFixed = styled(ModalButtonWrapper)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${space('lg')};
  justify-items: stretch;
  box-shadow: 0px 1px 41px rgba(0, 0, 0, 0.1);
  padding: ${space('x5')} ${space('x8')};
  position: relative;

  @media screen and (${query.below('tablet')}) {
    padding: ${space('xl')};
    grid-template-columns: 1fr;
  }
`;

export const ModalButtonFixed = styled(ModalButton)`
  padding: ${space('sm')} ${space('x5')};
  ${({ $isDisable }) =>
    $isDisable &&
    `background-color: lightgrey;
    cursor: not-allowed;
  `}

  @media screen and (${query.below('tablet')}) {
    width: 100%;
  }
`;

export const ModalButtonSecondFixed = styled(ModalButtonSecond)`
  padding: ${space('sm')} ${space('x5')};
  @media screen and (${query.below('tablet')}) {
    margin: 0;
    width: 100%;
  }
`;
